
(function(){
  'use strict';
  function plvLee(t){
  t=String(t==null?'':t);
  var m=/[0-9](?:[0-9.,'\u00a0\u202f ]*[0-9])?/.exec(t);
  if(!m)return null;
  var run=m[0],last=-1,ch='',i;
  for(i=run.length-1;i>=0;i--){var c=run.charAt(i);if(c<'0'||c>'9'){last=i;ch=c;break;}}
  var dec='',nd=0,mil='';
  if(last>=0){
    var tras=run.length-1-last,otros=run.slice(0,last).replace(/[0-9]/g,'');
    if((ch==='.'||ch===',')&&(tras<3||(tras===3&&otros.length>0&&otros.indexOf(ch)===-1))){dec=ch;nd=tras;mil=otros.charAt(0);}
    else{mil=ch;}
  }
  if(!mil)mil=dec===','?'.':',';
  var n=parseInt(run.replace(/[^0-9]/g,''),10);
  if(!isFinite(n)||n<=0)return null;
  return {n:n,nd:nd,dec:dec,mil:mil,pre:t.slice(0,m.index),suf:t.slice(m.index+run.length)};
}
function plvPinta(v,m){
  var s=String(Math.round(v));
  while(s.length<=m.nd)s='0'+s;
  var ent=m.nd?s.slice(0,s.length-m.nd):s,fr=m.nd?s.slice(s.length-m.nd):'',g='',i;
  for(i=0;i<ent.length;i++){if(i>0&&(ent.length-i)%3===0)g+=m.mil;g+=ent.charAt(i);}
  return m.pre+g+(m.nd?m.dec+fr:'')+m.suf;
}
function plvCuenta(c,p){return c-Math.floor(c*Math.round(p*100)/10000);}
  function plvInferior(el,m,q,p){
  if(!el)return '';
  var txt=el.getAttribute('data-txt')||'';
  if(!/\{(?:ahorro|x)\}/.test(txt))return txt;
  if(!m)return '';
  var ahorro=plvPinta((m.n-plvCuenta(m.n,p))*q,m);
  return txt.replace(/\{(?:ahorro|x)\}/g,function(){return ahorro;});
}
  var yo=document.currentScript,box=yo?yo.previousElementSibling:null;
  if(!box||!box.hasAttribute||!box.hasAttribute('data-pl-vol')){
    box=null;var todos=document.querySelectorAll('[data-pl-vol]');
    for(var a=0;a<todos.length;a++){if(!todos[a].getAttribute('data-pl-vol-listo')){box=todos[a];break;}}
  }
  if(!box||box.getAttribute('data-pl-vol-listo'))return;
  /* APAGADAS: el producto ya no tiene sus tramos (el descuento de la tienda se
     borro o se apago) y quien sirve la pagina las ha marcado. No se toca nada:
     ni la cantidad ni el boton de compra. */
  if(box.hasAttribute('data-pl-vol-off'))return;
  box.setAttribute('data-pl-vol-listo','1');
  var sc=(box.closest&&box.closest('.pl-hero'))||document;
  var cards=box.querySelectorAll('.pl-vol-c');
  function precio(){return sc.querySelector('.pl-price .pl-now')||sc.querySelector('.pl-now');}
  function pon(el,t){if(el&&el.textContent!==t)el.textContent=t;}
  function conTexto(el,v){return el?String(el.getAttribute('data-txt')||'{x}').replace('{x}',v):'';}
  /* El importe del boton de compra: lo que cuesta la tarjeta elegida. Sin el,
     con 3 unidades elegidas el boton seguiria diciendo el precio de una. */
  function boton(m){
    var cta=sc.querySelector('.pl-buy .pl-ctaamt');if(!cta||!m)return;
    var on=box.querySelector('.pl-vol-c.pl-vol-on');
    var q=on?unidades(on):1,p=on?(parseFloat(on.getAttribute('data-p'))||0):0;
    pon(cta,plvPinta(plvCuenta(m.n,p)*q,m));
  }
  function repinta(){
    var el=precio(),m=el?plvLee(el.textContent):null;
    for(var i=0;i<cards.length;i++){
      var c=cards[i],q=parseInt(c.getAttribute('data-q'),10)||1,p=parseFloat(c.getAttribute('data-p'))||0;
      var cada=c.querySelector('[data-vol-cada]'),tot=c.querySelector('[data-vol-total]'),ref=c.querySelector('[data-vol-ref]'),aho=c.querySelector('[data-vol-ahorro]');
      pon(aho,plvInferior(aho,m,q,p));
      if(!m){pon(cada,'');pon(tot,'');pon(ref,'');continue;}
      var u=plvCuenta(m.n,p),t=u*q,r=m.n*q;
      pon(tot,plvPinta(t,m));
      pon(cada,q>1?conTexto(cada,plvPinta(u,m)):'');
      pon(ref,r>t?plvPinta(r,m):'');
    }
    boton(m);
  }
  function cantidad(q){
    var e=document.getElementById('sp-qty');if(!e)return;
    e.style.display='none';
    /* La pagina horneada lleva la cantidad en un <span>; la seccion nativa, en
       el <input name="quantity"> de su formulario (el que leen Shopify y el
       pago expres). Se escribe en el que haya. */
    var sp=e.querySelector('span');if(sp)sp.textContent=String(q);
    var en=e.querySelector('input[name="quantity"]');if(en)en.value=String(q);
  }
  function unidades(c){return parseInt(c.getAttribute('data-q'),10)||1;}
  function elige(c){
    for(var i=0;i<cards.length;i++){
      var on=cards[i]===c;
      if(on)cards[i].classList.add('pl-vol-on');else cards[i].classList.remove('pl-vol-on');
      cards[i].setAttribute('aria-pressed',on?'true':'false');
    }
    cantidad(unidades(c));
    var el=precio();boton(el?plvLee(el.textContent):null);
  }
  function engancha(c){c.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();elige(c);});}
  for(var k=0;k<cards.length;k++)engancha(cards[k]);
  repinta();
  var el0=precio();
  if(el0&&window.MutationObserver){new window.MutationObserver(repinta).observe(el0,{childList:true,characterData:true,subtree:true});}
  function alCargar(){var on=box.querySelector('.pl-vol-c.pl-vol-on');cantidad(on?unidades(on):1);var el=precio();boton(el?plvLee(el.textContent):null);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',alCargar);}else{alCargar();}
})();
